import { Icon, IconButton, Td, Tr } from "@chakra-ui/react";
import { t } from "i18next";
import { Dispatch, SetStateAction, useState } from "react";
import { FaRegComments } from "react-icons/fa";
import { BseDto, ReceivedBseBidDto } from "../../../../../autogen/bff-api";
import { Message } from "../../../../../common/ConversationModal";
import { ProductFieldCell } from "../../../../../common/products/ProductFieldCell";
import { Product, ProductDraft, ProductGroup } from "../../../../../common/types";
import { useNegotiation } from "../NegotiationContext";
import { getAwardedProductPrice, getAwardedProductSuppliers, getSelectedOrWinningBids } from "./BidEvaluationUtils";

export const EvaluationReportRow = ({
  product,
  group,
  bids,
  sourcingEvent,
  setProductConversation,
}: {
  product: Product;
  group: ProductGroup;
  bids?: ReceivedBseBidDto[];
  sourcingEvent: BseDto;
  setProductConversation: Dispatch<
    SetStateAction<
      | {
          conversation: Message[];
          title: string;
          productGroup: ProductGroup;
          product: Product | ProductDraft;
        }
      | undefined
    >
  >;
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const toggle = () => setIsExpanded((expanded) => !expanded);
  const { currentRound } = useNegotiation();
  const selectedBids = getSelectedOrWinningBids(sourcingEvent, currentRound);
  return (
    <Tr key={product.id}>
      {group.productFields
        .filter((field) => field.populatedBy === "Buyer")
        .map((field) => (
          <ProductFieldCell
            key={field.name}
            value={product.productFields.find((f) => f.name === field.name)?.value}
            isBoolean={field.type === "Boolean"}
            isExpanded={isExpanded}
            onToggle={toggle}
            fadeToColor="smBackground"
            minWidth="40"
            pt="4"
            pb="0"
          />
        ))}
      <Td minWidth="40" verticalAlign={"top"} py="4">
        {product.quantity.value}
      </Td>
      <Td textAlign={"right"} verticalAlign={"top"} fontWeight={"bold"} py="4" pr="1">
        {getAwardedProductPrice({
          group,
          productId: product.id,
          bids: bids ?? [],
          selectedBids,
        })
          ? getAwardedProductPrice({
              group,
              productId: product.id,
              bids: bids ?? [],
              selectedBids,
            })?.toLocaleString()
          : ""}
      </Td>
      {
        <Td textAlign={"center"} verticalAlign={"top"} p="1">
          {getAwardedProductSuppliers({
            group,
            productId: product.id,
            bids: bids ?? [],
            selectedBids,
          })}
        </Td>
      }
      <Td verticalAlign={"top"} p="1">
        <IconButton
          variant={"outline"}
          aria-label="Product comments"
          icon={<Icon as={FaRegComments} />}
          onClick={() =>
            setProductConversation({
              conversation:
                product.conversation?.map((msg, i) => ({
                  id: `${i}`,
                  value: msg.comment,
                  createdBy: `${msg.createdBy?.firstName} ${msg.createdBy?.lastName}`,
                  createdAt: msg.createdAt,
                })) ?? [],
              title: `${t("Conversation regarding product")} - ${product.productFields[0].value}`,
              product,
              productGroup: group,
            })
          }
        />
      </Td>
    </Tr>
  );
};
